import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { semester } from '@app/_models/semester';
import { headervalue } from 'src/headervalue/header';
import {Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class SemesterService {
  url: string;
  constructor(private http: HttpClient) { }

  getSemester() {
    var temp = this.http.get<any>(`${environment.apiUrl}/semester/getAllSemList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  

  addSemester(semesterParam: semester): Observable<semester> {
    return this.http.post<semester>(`${environment.apiUrl}/semester/saveSem`,semesterParam, httpOptions).pipe( );
  }

  updateSemester(semesterParam: semester): Observable<semester> {
    return this.http.post<semester>(`${environment.apiUrl}/semester/updateSem`,semesterParam, httpOptions).pipe( );
  }

  deleteSemester(id) {
    return this.http.delete<semester>(`${environment.apiUrl}/semester/deleteSemester/`+id, httpOptions).pipe( );
  }


}